import React from 'react';
import { Card } from 'ui';

const ElementUsage = ({
  pagination,
  totalSections,
  totalLessons,
  sections,
}) => {
  return (
    <Card className="d-f f-d-r ff-ss">
      <Card.Content
        className="w-260 f-sh-0 border-right border-gray-light"
        padding="larger"
      >
        <h4 className="ff-ss fw-b f-smooth mb-8">
          {t('element_builder.usage.title')}
        </h4>
        <p className="fz-18">
          {t('element_builder.usage.times_used', {
            count: totalSections,
          })}{' '}
          {t('element_builder.usage.in_lessons', {
            count: totalLessons,
          })}
        </p>
      </Card.Content>
      <Card.Content className="f-1" padding="larger">
        <h2 className="ff-ss fw-b f-smooth mb-24">
          {t('element_builder.usage.element_sections_title')}
        </h2>
        <ul className="ls-n fz-bigger">
          {sections.map(section =>
            !section.lesson.archived ? (
              <li className="mb-16 hang-indent c-brand-blue" key={section.id}>
                <a href={section.url} target="_blank" rel="noopener noreferrer">
                  {section.lesson.title}: {section.title}{' '}
                  {`(${
                    section.published
                      ? t('drafts.state.published')
                      : t('drafts.state.draft')
                  })`}
                </a>
              </li>
            ) : (
              <li className="mb-16 hang-indent" key={section.id}>
                {section.lesson.title}: {section.title}{' '}
                {`(${
                  section.published
                    ? t('drafts.state.published')
                    : t('drafts.state.draft')
                })`}
                {` (${t('metadata.archived')})`}
              </li>
            ),
          )}
        </ul>
        {pagination}
      </Card.Content>
    </Card>
  );
};

export default ElementUsage;
